module.exports = __webpack_public_path__ + "static/image2@2x-44cc818bf79f2cac293e8a2c728543a2.png";